import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.colors.colorf3f5f9
}))`
  position: relative;
  padding-top: 16px;
  max-height: 60vh;
  overflow-y: auto;

  ${VerticalStyledScrollBar}
`

export const ContainerWithListHeight = styled.div<{ height: number }>`
  position: relative;
  height: ${({ height }) => height}px;
`

export const ListWithVisibleItems = styled.div<{ scrollPosition: number }>`
  position: absolute;
  width: 100%;
  top: ${({ scrollPosition }) => scrollPosition}px;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(233px, 1fr));
  gap: 16px;
`
